import { render, staticRenderFns } from "./MarketingPreferencesModal.vue?vue&type=template&id=1162d928&scoped=true&"
import script from "./MarketingPreferencesModal.vue?vue&type=script&lang=js&"
export * from "./MarketingPreferencesModal.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPreferencesModal.vue?vue&type=style&index=0&id=1162d928&lang=scss&scoped=true&"
import style1 from "./MarketingPreferencesModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1162d928",
  null
  
)

export default component.exports